import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=0f00575b&scoped=true&"
import script from "./SideMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuItem.vue?vue&type=style&index=0&id=0f00575b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00575b",
  null
  
)

export default component.exports